/* eslint-disable react/display-name */
import React, { useEffect } from 'react';
import { Handle } from 'reactflow';
import { useParams } from 'react-router-dom';
import { Typography, Tooltip } from '@mui/material';
import { useJourney } from '../../../../../api/Journeys/journey_queries';
import { isEmpty } from 'lodash';
import useLocalStore from '../../../../../useLocalStore';

import { StepTypeIcon } from '../../../JourneyConstants';

const HANDLE_STYLE = {
    height: 1,
    width: 1,
    background: 'transparent',
    border: 0
};

const EnterEditNode = React.memo(({ data }) => {
    const { id: journeyIdStr } = useParams();
    const journeyId = parseInt(journeyIdStr);

    const { isDisabled, stepId } = data;
    const { isFetching, data: journey } = useJourney(journeyId);
    const [ hasTrigger, setHasTrigger ] = React.useState(false);

    const [setSidebar] = useLocalStore((state) => [state.setSidebar]);

    const handleSidebar = () => {
        const payload = {
            open: true,
            name: 'JourneyTrigger',
            params: {
                flowId: journeyId
            }
        };

        setSidebar(payload);
    };

    React.useEffect(() => {
        const isTriggerSet = journey && journey?.status === 'draft' && isEmpty(journey?.flow_trigger);
        setHasTrigger(isTriggerSet);
    }, [journey]);

    const unsetTriggerClass = hasTrigger ? 'highlight' : '';

    return (
        <div style={{margin: 'auto', cursor: 'pointer'}} onClick={handleSidebar}>
            {/*<Tooltip title='Set Journey Trigger' open={Boolean(hasTrigger)} PopperProps={{ disablePortal: true }} placement='right'>*/}
                <div className={!isDisabled ? `flow-enter-node ${unsetTriggerClass}` : `flow-enter-node ${unsetTriggerClass} disabled`}>
                    <div className='node-icon' style={{ marginRight: '4px' }}>
                        <StepTypeIcon step={{ type: 'enter' }} fontSize='small' color='primary' />
                    </div>
                    <Typography variant='caption' component='div' style={{fontWeight: 400, fontSize: 12}}>
                        Enter
                    </Typography>
                </div>
            {/*</Tooltip>*/}
            <Handle
                type='source'
                position='bottom'
                style={HANDLE_STYLE}
                onConnect={(params) => console.log('handle onConnect', params)}
            />
        </div>
    );
});

export default EnterEditNode;
